export function formatLargeNumber(value: string | number | undefined | null): string {
  const numValue = Number(value);

  if (!value || isNaN(numValue)) return '0';

  if (numValue >= 1000000) {
    const millions = (numValue / 1000000);
    // Remove .0 if it exists
    return millions % 1 === 0 ? Math.floor(millions) + 'M' : millions.toFixed(1) + 'M';
  }
  if (numValue >= 1000) {
    const thousands = (numValue / 1000);
    // Remove .0 if it exists
    return thousands % 1 === 0 ? Math.floor(thousands) + 'K' : thousands.toFixed(1) + 'K';
  }

  return numValue.toString();
}
